module.exports = __webpack_public_path__ + "static/media/globe-stand.99d900a8.svg";